/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Signup_PromptInputs */

const es_co2_login_signup_prompt = /** @type {(inputs: Login_Signup_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Aún no tienes cuenta?`)
};

/**

* @param {Login_Signup_PromptInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const login_signup_prompt = /** @type {((inputs?: Login_Signup_PromptInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Signup_PromptInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_login_signup_prompt(inputs)
});